<template>
  <div class="fa">
    <!--<el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      active-text-color="#409EFF"
      @select="handleSelect"
      background-color="#fff"
    >
      <el-menu-item index="1">对账</el-menu-item>
      <el-submenu index="2">
        <template slot="title">查看单据</template>
        <el-menu-item index="2-1">已付款</el-menu-item>
        <el-menu-item index="2-2">未付款</el-menu-item>
        <el-menu-item index="2-3"></el-menu-item> 
        
      </el-submenu>
      <el-menu-item index="4">订单管理</el-menu-item>
    </el-menu>-->
    <div class="thead">
      <!-- <li
       :class="duizhang?'li-checked':''"
        @click="
          danju_in = false;
          danju_out = false;
          duizhang = true;
        "
      >
        对账功能
      </li> -->
      <li
      :class="danju_in?'li-checked':''"
        @click="
          danju_in = true;
          danju_out = false;
          duizhang = false;
        "
      >
        入库单
      </li>
      <li
      :class="danju_out?'li-checked':''"
        @click="
          danju_out = true;
          danju_in = false;
          duizhang = false;
        "
      >
        出库单
      </li>
      <!-- <li>生成进货单</li> -->
    </div>
    <div class="div-fa" v-if="danju_in">
      <div>
        <el-input
          placeholder="请输入内容"
          v-model="input_in"
          class="input-with-select"
        >
          <el-select v-model="select_in" slot="prepend" placeholder="请选择">
            <el-option label="单号" value="1"></el-option>
            <el-option label="供应商" value="2"></el-option>
            <el-option label="结款人" value="3"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <el-table
        :data="fukuan_list"
        height="540"
        :stripe="true"
        :border="true"
        :header-cell-style="{ background: '#92e28494', color: '#606266' }"
      >
        <el-table-column prop="document_id" label="单号" width="200">
        </el-table-column>
        <el-table-column prop="date" sortable label="创建日期" width="150">
        </el-table-column>
        <el-table-column prop="money" sortable label="金额" width="100">
        </el-table-column>
        <el-table-column prop="vendor" label="供应商" width="200">
        </el-table-column>
        <el-table-column prop="name" label="审核人" width="100">
        </el-table-column>
        <el-table-column prop="pay" label="付款状况" width="80">
        </el-table-column>
        <el-table-column prop="date" sortable label="结款日期" width="150">
        </el-table-column>
        <el-table-column prop="name" label="结款人" width="100">
        </el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="viewDocuments(scope.$index, shoukuan_list)"
              type="text"
            >
              查看
            </el-button>
            <el-button
              @click.native.prevent="duiZhang(scope.$index, shoukuan_list)"
              type="text"
            >
              对账
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="div-fa" v-if="danju_out">
      <div>
        <el-input
          placeholder="请输入内容"
          v-model="input_out"
          class="input-with-select"
        >
          <el-select v-model="select_out" slot="prepend" placeholder="请选择">
            <el-option label="单号" value="1"></el-option>
            <el-option label="供应商" value="2"></el-option>
            <el-option label="结款人" value="3"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <el-table
        :data="shoukuan_list"
        height="540"
        :stripe="true"
        :border="true"
        :header-cell-style="{ background: '#92e28494', color: '#606266' }"
      >
        <el-table-column prop="document_id" label="单号" width="200">
        </el-table-column>
        <el-table-column prop="date" sortable label="创建日期" width="150">
        </el-table-column>
        <el-table-column prop="money" sortable label="金额" width="100">
        </el-table-column>
        <el-table-column prop="vendor" label="客户" width="200">
        </el-table-column>
        <el-table-column prop="name" label="审核人" width="100">
        </el-table-column>
        <el-table-column prop="pay" label="付款状况" width="80">
        </el-table-column>
        <el-table-column prop="date" sortable label="结款日期" width="150">
        </el-table-column>
        <el-table-column prop="name" label="结款人" width="100">
        </el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="viewDocuments(scope.$index, shoukuan_list)"
              type="text"
            >
              查看
            </el-button>
            <el-button
              @click.native.prevent="duiZhang(scope.$index, shoukuan_list)"
              type="text"
            >
              对账
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="div-fa" v-if="duizhang">
      <el-container>
        <el-aside width="49%">
          <el-select
            class="el-select-document"
            v-model="value1"
            filterable
            placeholder="择手持机导入的单据"
          >
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-table
            :data="tableData1"
            border
            height="350"
            :summary-method="getSummaries"
            show-summary
            :cell-style="{ padding: '4px 0' }"
            :header-cell-style="{padding: '6px 0' ,}"
            style="width: 100%; margin-top: 20px"
          >
            <el-table-column
              prop="barcode"
              sortable
              label="商品条码"
              width="130"
              
            >
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" width="180">
            </el-table-column>
            <el-table-column prop="price" label="价格"> </el-table-column>
            <el-table-column prop="quantity" label="数量"> </el-table-column>
            <el-table-column prop="money" label="金额"> </el-table-column>
          </el-table>
        </el-aside>
        <el-main class="el-main-fadiv">
          <div>
            <el-select
              class="el-select-document"
              v-model="value2"
              filterable
              placeholder="请选择系统单据"
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <el-table
            :row-class-name="tableRowClassName"
            :data="tableData2"
            border
            height="350"
            :summary-method="getSummaries"
            show-summary
            :cell-style="{ padding: '4px 0'}"
            :header-cell-style="{padding: '6px 0' ,}"
            style="width: 100%; margin-top: 20px"
          >
            <el-table-column
              prop="barcode"
              sortable
              label="商品条码"
              width="130"
            >
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" width="180">
            </el-table-column>
            <el-table-column prop="price" label="价格"> </el-table-column>
            <el-table-column prop="quantity" label="数量"> </el-table-column>
            <el-table-column prop="money" label="金额"> </el-table-column>
          </el-table>
        </el-main>
      </el-container>
      <el-card>
        <el-button type="primary" @click="contrastTable">一键对比</el-button>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["reload"],
  data() {
    return {
      danju_in: true,
      danju_out: false,
      duizhang: false,
      activeIndex: "1",
      input_in: "",
      select_in: "",
      input_out: "",
      select_out: "",
      fukuan_list: [
        {
          document_id: "In-YLM-2022-2-20-1",
          date: "2016-05-02",
          name: "王小虎",
          money: 9601,
          vendor: "青岛洗化22222222222222",
          pay: "已付"
        },
        {
          document_id: "In-YLM-2022-2-20-1",
          date: "2016-05-04",
          name: "王小虎",
          money: 9602,
          vendor: "青岛洗化",
          pay: "已付"
        },
        {
          document_id: "In-YLM-2022-2-20-1",
          date: "2016-05-01",
          name: "王小虎",
          money: 9603,
          vendor: "青岛洗化",
          pay: "已付"
        },
        {
          document_id: "In-YLM-2022-2-20-1",
          date: "2016-05-03",
          name: "王小虎",
          money: 9604,
          vendor: "青岛洗化",
          pay: "已付"
        }
      ],
      shoukuan_list: [
        {
          document_id: "In-YLM-2022-2-20-1",
          date: "2016-05-02",
          name: "王小虎",
          money: 9601,
          vendor: "青岛洗化22222222222222",
          pay: "已付"
        },
        {
          document_id: "In-YLM-2022-2-20-1",
          date: "2016-05-04",
          name: "王小虎",
          money: 9602,
          vendor: "青岛洗化",
          pay: "已付"
        },
        {
          document_id: "In-YLM-2022-2-20-1",
          date: "2016-05-01",
          name: "王小虎",
          money: 9603,
          vendor: "青岛洗化",
          pay: "已付"
        },
        {
          document_id: "In-YLM-2022-2-20-1",
          date: "2016-05-03",
          name: "王小虎",
          money: 9604,
          vendor: "青岛洗化",
          pay: "已付"
        }
      ],
      value1: "",
      value2: "",
      options1: [
        {
          value: "1",
          label: "黄金糕"
        },
        {
          value: "2",
          label: "双皮奶"
        },
        {
          value: "3",
          label: "蚵仔煎"
        },
        {
          value: "4",
          label: "龙须面"
        },
        {
          value: "5",
          label: "北京烤鸭"
        }
      ],
      options2: [
        {
          value: "1",
          label: "黄金糕"
        },
        {
          value: "2",
          label: "双皮奶"
        },
        {
          value: "3",
          label: "蚵仔煎"
        },
        {
          value: "4",
          label: "龙须面"
        },
        {
          value: "5",
          label: "北京烤鸭"
        }
      ],
      tableData1: [
        {
          barcode: "6947022211111",
          goods_name: "品味幸福抽纸",
          price: 10,
          quantity: 11,
          money: 90
        },
        {
          barcode: "9999999999999",
          goods_name: "品味幸福抽纸",
          price: 10,
          quantity: 55,
          money: 550
        },
        {
          barcode: "6211312",
          goods_name: "品味幸福抽纸",
          price: 10,
          quantity: 14,
          money: 140
        },
        {
          barcode: "694702121121",
          goods_name: "品味幸福抽纸",
          price: 10,
          quantity: 99,
          money: 110
        }
      ],
      tableData2: [
        {
          barcode: "6947022211111",
          goods_name: "品味幸福抽纸",
          price: 10,
          quantity: 9,
          money: 90
        },
        {
          barcode: "9999999999999",
          goods_name: "品味幸福抽纸",
          price: 10,
          quantity: 55,
          money: 550
        },
        {
          barcode: "6211312",
          goods_name: "品味幸福抽纸",
          price: 10,
          quantity: 14,
          money: 140
        },
        {
          barcode: "694702121121",
          goods_name: "品味幸福抽纸",
          price: 10,
          quantity: 11,
          money: 110
        }
      ],
      difference_list: []
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      //   console.log(key, keyPath);
    },
    viewDocuments(index, rows) {
      if (this.danju_in === true) {
        localStorage.setItem("activePath", "/in");
        this.$router.push({
          name: "in",
          params: {
            document_id: rows[index].merchant_id
          }
        });
        this.reload();
      } else if (this.danju_out === true) {
        localStorage.setItem("activePath", "/out");
        this.$router.push({
          name: "out",
          params: {
            document_id: rows[index].merchant_id
          }
        });
        this.reload();
      }
    },
    duiZhang(index, rows) {
      //   console.log(rows);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        console.log(column.property);
        if (column.property === "money") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });
      return sums;
    },
    // 一键对比
    contrastTable() {
      var temp = {};
      var temp1 = {};
      /* for(var i=0;i<this.tableData1.length-1;i++){
          for(var j=0;j<this.tableData1.length-1-i;j++){
              if(this.tableData1[j].barcode>this.tableData1[j+1].barcode){
                  temp=this.tableData1[j]
                  this.tableData1[j]=this.tableData1[j+1];
                  this.tableData1[j+1]=temp
              }
          }
      }
      for(var i=0;i<this.tableData2.length-1;i++){
          for(var j=0;j<this.tableData2.length-1-i;j++){
              if(this.tableData2[j].barcode>this.tableData2[j+1].barcode){
                  temp=this.tableData2[j]
                  this.tableData2[j]=this.tableData2[j+1];
                  this.tableData2[j+1]=temp
              }
          }
      } */
      var that = this;
      this.tableData1.forEach(function(item, i, arr) {
        that.tableData2.forEach(function(item1, index, arr1) {
          if (item.barcode == item1.barcode) {
            if (
              item.price != item1.price ||
              item.quantity != item1.quantity ||
              item.money != item1.money
            ) {
              that.difference_list.push(arr[i]);
            }
          }
        });
      });
      console.log(this.difference_list);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      }
      return "";
    }
  }
};
</script>
<style scoped>
.div-fa {
  padding:20px 20px 0 20px;
}
.el-menu-demo {
  /* height: 40px; */
  width: 101%;
}
.thead >>> li {
  width: 200px;
  text-align: center;
  height: 25px;
  float: left;
  list-style: none;
  border-right: 1px solid rgb(170, 170, 170);
  /* margin-top: 4px; */
  cursor: pointer;
  line-height: 1.5;
}
.thead {
  width: 100%;
  height: 25px;
  background-color: rgb(230, 230, 230);
}
.el-select {
  width: 150px;
}
.el-main-fadiv {
  margin: -20px 0 0 -10px;
}
.el-select-document {
  width: 99%;
}
.el-table .warning-row {
background: rgb(161, 120, 43) !important; 
}
.li-checked {
  background-color: #ffffff;
  color: rgb(94, 94, 94);
}
</style>
